import { useQuery } from "@apollo/client";

import useCourtInformation from "hooks/me/useCourtInformation";

import getVariablesForAllLawyersQuery from "utils/lawyers/getVariablesForAllLawyersQuery";

import ALL_LAWYERS from "@gql/sanity/allLawyers";

export const useSharedLawyersQuery = ({ user, entityObject }) => {
  const { provinceShorthand: residence } = useCourtInformation(user?.client);

  const { data, refetch, loading } = useQuery(ALL_LAWYERS, {
    variables: getVariablesForAllLawyersQuery({ residence }),
    skip: entityObject?.isOurClient,
  });

  return { sharedLawyers: data?.allLawyer || [], loading, refetch };
};
